import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { fetchLocationSuggestions } from "@/services/api/location/suggestions";

// Query keys for React Query
export const locationQueryKeys = {
  suggestions: (query: string) => ["location", "suggestions", query] as const
};
export const useLocationSuggestions = (query, t0) => {
  const $ = _c(8);
  const enabled = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== query) {
    t1 = locationQueryKeys.suggestions(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== query) {
    t2 = () => fetchLocationSuggestions(query);
    $[2] = query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = enabled && query.length >= 3;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: 300000,
      gcTime: 300000,
      retry: 2,
      retryDelay: 1000
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
};